import { DataObject } from '@shared/models/data-object.model';
import { EntityType } from '@shared/models/entity-enum';
import { UserPermission } from '@shared/models/user-permissions.model';
import { Observable } from 'rxjs';

export abstract class RecordsUserPermission extends UserPermission {
  abstract isRecordEditable(entity: EntityType, record: DataObject): Observable<boolean>;
  abstract canPublishListings(): Observable<boolean>;
}
